import initialState from './initialState'

/**
 * @description
 * set status, token, user and hasLoadedOnce after success user login
 * 
 * @param {object} state
 * @return {void}
 */
const authSuccess = (state, token) => {
    state.status = 'success'
    state.token = token
    state.user = JSON.parse(localStorage.getItem('user'))
    state.hasLoadedOnce = true
}

/**
 * @description
 * 
 * set token to void after user logout
 * @param {Object} state
 * @return {void} 
 */
const authLogout = (state) => {
    state.token = ''
}

/**
 * @description
 * Sets the user.
 *
 * @param      {<type>}  state   The state
 * @param      {<type>}  user    The user
 */
const setUser = (state, user) => {
	state.user = user
}

/**
 * @description
 * Sets the user storage.
 *
 * @param      {<type>}  state   The state
 * @param      {<type>}  user    The user
 */
const setUserStorage = (state, user) => {
    localStorage.setItem('user', JSON.stringify(user))
}

/**
 * @description
 * 
 * Returns State to it's initial values
 * @param {*} state
 */
const resetState = (state) => {
    Object.assign(state, initialState())
}

export default {
    authSuccess,
    authLogout,
    resetState,
    setUser,
    setUserStorage,
}